export default "__VITE_ASSET__DJguVrMh__"